import { Component, OnInit } from '@angular/core';
import { AuthService } from '@shared/services/auth/auth.service';
import { LoggingService } from '@shared/services/logging/logging.service';
import { LOGIN_BACKDOOR_URL_KEY } from '@shared/guards/engage-redirect-guard';

@Component({
  selector: 'app-login-backdoor',
  templateUrl: './login-backdoor.component.html'
})
export default class LoginBackDoorComponent implements OnInit {

  constructor(
    private logging: LoggingService,
    private authService: AuthService) {}

  ngOnInit(): void {
    this.setTenant();
  }

  public setTenant(): void {
    const params = new URLSearchParams(document.location.search);
    const tenantId = params.get('tenantid');
    const pageEncoded = params.get('page');

    if (!pageEncoded) {
      this.logging.log.info(`LoginBackdoorComponent: No page querystring parameter found`);
      return;
    }
    if (!tenantId) {
      this.logging.log.info(`LoginBackdoorComponent: No tenantid querystring parameter found`);
      return;
    }

    const page = decodeURI(pageEncoded);
    // explanation:
    // User visits: https://invitedesk.com?login-backdoor=123
    // Then authService.requestNewAccessToken('123') is called, which triggers the login flow with the new tenant
    sessionStorage.setItem(LOGIN_BACKDOOR_URL_KEY, page);
    this.logging.log.info(`AppComponent: changing tenant to ${tenantId} from querystring`);
    this.authService.requestNewAccessToken(tenantId);
  }
}
